import $ from "lc-jquery";
import drm from "dynamic-module-registry";
const chatFive9Context = drm.get("chatFive9Context");
import React, { Fragment } from "react";
import { hydrate } from "react-dom";
import ChatWidget from "../five9-chat-widget";

if (window.lcTracking) {
  require("lc-tracking/src/client");
}

// Handle refreshing the page so it's not loaded from cache
$(window).bind("pageshow", function (event) {
  if (event.originalEvent.persisted) {
    window.location.reload();
  }
});

function setHeight() {
  var windowHeight = $(window).innerHeight() - 280; // length of header+footer
  $(".main-content").css("min-height", windowHeight);
}

var dependencies = {
  common: require("./common.less"),
  footer: require("ui-footer"),
};

hydrate(
  <Fragment>
    {chatFive9Context?.isFiveChatEnabled && (
      <ChatWidget chatFive9Context={chatFive9Context} />
    )}
  </Fragment>,
  document.getElementById("five9-chat-wrapper"),
);

(function () {
  var $mobileBtn = $("#com-header #com-header-mobile-btn");
  var $currentMobileMenu;

  var closeMobileMenu = function (event) {
    // if clicked outside menu, then prevent outside link clicks and close menu
    if ($currentMobileMenu.has(event.target).length === 0) {
      event.preventDefault();
      $currentMobileMenu.addClass("hidden");
    }
  };

  $mobileBtn.on("click", function (event) {
    $currentMobileMenu = $(this).parent().find(".com-header-mobile-popup");

    if ($currentMobileMenu.hasClass("hidden")) {
      event.stopPropagation();
      $currentMobileMenu.removeClass("hidden");
      $("html").one("touchstart click", closeMobileMenu); // just one time
    } else {
      closeMobileMenu(event);
    }
  });

  // Only need to do for Safari because of vh. Other browsers take care of this.
  if (
    navigator.userAgent.search("Safari") >= 0 &&
    navigator.userAgent.search("Chrome") < 0
  ) {
    setHeight();
    $(window).resize(function () {
      setHeight();
    });
  }
})();

// Exporting dependencies for testing
module.exports = dependencies;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/favicon.ico');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/global_sprite.png');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/lc-logo.svg');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/LCPS-documents.png');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/lcps-logo.jpg');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/lending-club-logo.svg');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/patient-solutions.svg');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/pf_sprite_home.png');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/welcome-dental.jpg');
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/shared_modules/base-layout/img/YTS-documents.png');